const getAvailability = (config)=>{
    if (!config.selectedVariants) {
        return {
            selectedVariantsData: [],
            availability: []
        };
    }
    const selectedVariantsData = Object.values(config.selectedVariants);
    const availability = selectedVariantsData.map((variant)=>{
        if (variant && variant.availability && (config.leftEyeChecked && variant.sku === config.leftEyeBoxSKU || config.rightEyeChecked && variant.sku === config.rightEyeBoxSKU)) {
            return variant.availability;
        }
        return undefined;
    });
    return {
        selectedVariantsData,
        availability
    };
};

export { getAvailability };
//# sourceMappingURL=get-availability.js.map
